export default __webpack_public_path__ + "static/Graphik-Light-Web-78f2a1785ae17b7cc4cde04289e13808.woff";